import { content } from '../../config'

const { PLATFORM, AGENCY, APP_ID, APP_DESCRIPTION } = content

export const REQUEST_CONTANTS = {
	PLATFORM: PLATFORM,
	AGENCY: AGENCY,
	APP_ID: APP_ID,
	APP_DESCRIPTION: APP_DESCRIPTION
}
